<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <h3>寄送商店資訊給店家 - {{$route.query.shop_name}}</h3>

        <ul>
          <li>確認郵件內容，尚未編輯發信郵件請點擊「編輯發信樣板」編輯</li>
          <li>已編輯發信樣板，確認郵件內容（可微調），點擊「發信給店家」按鈕將發出開店郵件，並於附件戴上店家LINE點餐QRCode圖片</li>
        </ul>
        <div>
          <n-button native-type="submit" @click.native="gotoTemplate" type="info">編輯發信樣板</n-button>
        </div>
        
        <!-- <fg-input
          label="主旨"
          required
          v-model="subject"
          v-validate="modelValidations.subject"
          :error="getError('subject')"
          name="subject"
        ></fg-input> -->
        <!-- bidirectional data binding（双向数据绑定） -->
        <!-- <quill-editor
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
        ></quill-editor> -->

        <el-button v-if="user && user.type === 'gaa'" type="primary" size="mini" @click.native="switchEditor('ace')">原始碼編輯</el-button>
        <el-button v-if="user && user.type === 'gaa'" type="primary" size="mini" @click.native="switchEditor('ckeditor')">一般編輯</el-button><span class="mx-2">(請注意，一切換到一般編輯器即會改動部分HTML語法)</span>

        <div v-if="loading">載入資料中...</div>
        <formio src="" url="" :form="emailForm" submission="" options="" v-on:submit="formioSubmit"></formio>       
        <!-- <div class="d-flex justify-content-center">
          <n-button
            native-type="submit"
            @click.native.prevent="validate"
            type="success"
          >發信給店家 {{to}}</n-button>
        </div> -->
        <!-- Or manually control the data synchronization（或手动控制数据流） -->
        <!-- <quill-editor :content="content" :options="editorOption" @change="onEditorChange($event)"></quill-editor> -->
      </card>
      <!-- small modal -->
      <modal
        :show.sync="modals.mini"
        :class="modals.class"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <!-- <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>-->
        <p>
          <strong>{{modals.content}}</strong>
        </p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

// require styles
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";

// import { quillEditor } from "vue-quill-editor";

import { Form } from 'vue-formio';

import { Modal } from "src/components";

export default {
  components: {
    // quillEditor,
    formio: Form, 
    Modal
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  data() {
    return {
      loading: true,
      siAccountId: null,
      emailForm: {
        "display": "form",
        "components": [
        ]
      },
      content: "",
      subject: "",
      to: "",
      editorOption: {
        // some quill options
      },
      modelValidations: {
        subject: {
          required: true
        }
      },
      modals: {
        content: "",
        mini: false,
        class: "modal-danger"
      }
    };
  },
  mounted() {
    this.renderEmail();
  },
  methods: {
    formioSubmit(event) {
      this.content = event.data.emailSource;
      this.subject = event.data.subject;
      this.validate();
    },
    switchEditor(editor) {
      if (editor === 'ace') {
          this.emailForm = {
            "display": "form",
            components: [
              {
                  "type": "button",
                  "label": "發信給店家" + this.to,
                  "customClass": "text-center",
                  "theme": "success",
                  "key": "submit",
                  "disableOnInvalid": true,
                  "input": true,
                  "tableView": false
              },
              {
                "label": "主旨",
                "tableView": true,
                "validate": {
                    "required": true
                },
                "defaultValue": this.subject || "",
                "key": "subject",
                "type": "textfield",
                "input": true
              },
              {
                "label": "原始碼編輯",
                // "autoExpand": false,
                "tableView": true,
                "key": "emailSource",
                "customClass": "editorSize",
                "editor": "ace",
                "placeholder": "",
                "wysiwyg": {
                  "maxHeight": 100,
                  "minLines": 10,
                  // "mode": "ace/mode/html", // vue-formio不支援javascript以外的mode
                  // "theme": "ace/theme/twilight",
                  "wrap": true,
                  // "autoScrollEditorIntoView": true
                },
                "validate": {
                  "required": true
                },
                "defaultValue": this.content || "",
                "type": "textarea",
                "input": true
                // "label": "Text Area",
                // "editor": "ace",
                // "tableView": true,
                // "key": "textArea",
                // "type": "textarea",
                // "input": true,
                // "isUploadEnabled": false
              }
            ]
            
          }
      } else {
          this.emailForm = {
            "display": "form",
            components: [
              {
                  "type": "button",
                  "label": "發信給店家" + this.to,
                  "customClass": "text-center",
                  "theme": "success",
                  "key": "submit",
                  "disableOnInvalid": true,
                  "input": true,
                  "tableView": false
              },
              {
                "label": "主旨",
                "tableView": true,
                "validate": {
                    "required": true
                },
                "defaultValue": this.subject || "",
                "key": "subject",
                "type": "textfield",
                "input": true
              },
              {
                  "label": "CKEDITOR",
                  "editor": "ckeditor",
                  "autoExpand": false,
                  "tableView": true,
                  "key": "emailSource",
                  "defaultValue": this.content || "",
                  "type": "textarea",
                  "input": true,
                  "isUploadEnabled": false
              }
            ]
            
          }
      }
    },
    gotoTemplate() {
      if (this.user.type === 'si') {
        this.$router.push(
          `/si-email-template?shop_id=${this.$route.query.shop_id}&shop_name=${this.$route.query.shop_name}`
        );
      } else if (this.user.type === 'gaa' && this.siAccountId) {
        this.$router.push(
        `/si-email-template?shop_id=${this.$route.query.shop_id}&shop_name=${this.$route.query.shop_name}&si_id=${this.siAccountId}`
      );
      }
      
    },
    renderEmail() {
      // render email by si account and shop data
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.$route.query.shop_id}/shop-info-email`
        )
        .then(response => {
          this.content = response.data ? response.data["content"] : "";
          this.subject = response.data ? response.data["subject"] : "";
          this.to = response.data ? response.data["owner"]["email"] : "";
          this.siAccountId = response.data ? response.data["si"]["siAccountId"] : null;
          if (this.user.type === 'gaa') {
            this.switchEditor('ace');
          } else if (this.user.type === 'si') {
            this.switchEditor('ckeditor');
          }
          
          this.loading = false;
          // console.log('the response ' + JSON.stringify(response.data));
          // self.model.email = response.data.email;
          // self.model.name = response.data.name;
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = "尚未編輯開店信件樣板，請先前往編輯";
          this.modals.class = "modal-danger";
          this.modals.mini = true;
        });
    },
    validate() {
      console.log("check content " + this.content);
      if (!this.content) {
        this.modals.content = "尚未編輯開店信件樣板，請先前往編輯";
        this.modals.class = "modal-danger";
        this.modals.mini = true;
      } else {
        return axios
          .post(
            `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.$route.query.shop_id}/shop-info-email`,
            {
              htmlContent: this.content,
              subject: this.subject
            }
          )
          .then(response => {
            // this.content = response.data;
            // console.log('the response ' + JSON.stringify(response.data));
            // self.model.email = response.data.email;
            // self.model.name = response.data.name;
            this.modals.class = "modal-success";
            this.modals.content = "發送成功";
            this.modals.mini = true;

            return response.data;
          })
          .catch(e => {
            if (e && e.data && e.data.message)
              this.modals.content = "尚未編輯開店信件樣板，請先前往編輯";

            this.modals.class = "modal-danger";
            this.modals.mini = true;
          });
      }
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>